import TagInput from './TagInput';
import TagInputContainer from './TagInput.container';

export default TagInputContainer(TagInput);